"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castell-alfero": {
    "cc397523": [{
      "hkey": "33783ceb",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "il-paese": [{
      "hkey": "33783ceb",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e9e3dbf3": [{
      "hkey": "aa4c5c71",
      "slug": "stazione",
      "name": "Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "la-stazione": [{
      "hkey": "aa4c5c71",
      "slug": "stazione",
      "name": "Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "63921001": [{
      "hkey": "a08598a8",
      "slug": "castell-alfero",
      "name": "Castell'Alfero",
      "primary": true,
      "skipSearch": false
    }],
    "serra-perno": [{
      "hkey": "a08598a8",
      "slug": "castell-alfero",
      "name": "Castell'Alfero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;